import React, { Component } from 'react'
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import loadScripts from '../../../dassets/js/custom';
class CompanyProfile extends Component {
    componentDidMount() {
      loadScripts();
    }
    constructor(props) {
        super(props);

        this.saveAndContinue = this.saveAndContinue.bind(this);
        this.onChangePassport = this.onChangePassport.bind(this);
        this.data = {
            passport: null
        }
    }

    saveAndContinue(e) {
        e.preventDefault()

        // Get values via this.refs
        let data = {
            company_name: this.refs.company_name.value,
            annual_turnover: this.refs.annual_turnover.value,
            reg_no: this.refs.reg_no.value,
            address: this.refs.address.value,
            nature_of_business: this.refs.nature_of_business.value,
            email: this.refs.email.value,
            telephone: this.refs.telephone.value,
            affiliations: this.refs.affiliations.value,
            id_no: this.refs.id_no.value,
            date_of_incorporation: this.refs.date_of_incorporation.value,
            passport: this.data.passport,
            passport_path: `cform_passport_${this.refs.company_name.value}_${this.refs.reg_no.value}_${new Date().getTime()}.png`,
        }

        this.props.saveValues(data)
        this.props.nextStep()
    }

    onChangePassport(e) {
        const fileTypes = ['image/png', 'image/gif', 'image/jpeg'];

        let file = e.target.files[0];
        if (fileTypes.every(extension => file.type !== extension)) {
            toast.error(`The file ${file.type} extension is not supported`);
            return
        }
        this.data.passport = file;
    }

    render() {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <h4 className="text-danger mb-4">Company's Profile</h4>
                                <form onSubmit={this.saveAndContinue}>
                                    <div className="row">
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Company Name<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="company_name" placeholder="Company Name"
                                                defaultValue={this.props.fieldValues.company_name} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Email Address<span className="text-danger">*</span></label>
                                            <Form.Control type="email" className="form-control" ref="email" placeholder="Email Address" defaultValue={this.props.fieldValues.email} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>RC Number<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="reg_no" placeholder="RC Number" defaultValue={this.props.fieldValues.reg_no} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Company Address<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="address" placeholder="Company Address" defaultValue={this.props.fieldValues.address} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Nature of Business<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control" ref="nature_of_business" placeholder="Nature of Business" defaultValue={this.props.fieldValues.nature_of_business} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Telephone Number<span className="text-danger">*</span></label>
                                            <Form.Control type="text" className="form-control uint" ref="telephone" placeholder="Telephone Number" defaultValue={this.props.fieldValues.telephone} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Affiliations</label>
                                            <Form.Control type="text" className="form-control" ref="affiliations" placeholder="Affiliations" defaultValue={this.props.fieldValues.affiliations} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Date of Incorporation<span className="text-danger">*</span></label>
                                            <Form.Control type="date" className="form-control" ref="date_of_incorporation" placeholder="Date of Incorporation" defaultValue={this.props.fieldValues.date_of_incorporation} required />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>Annual Turnover<span className="text-danger">*</span></label>
                                            <select ref="annual_turnover" required className="form-control" defaultValue={this.props.fieldValues.annual_turnover}>
                                                <option value="" hidden>Select...</option>
                                                <option value="50M - 99.9M">50M - 99.9M</option>
                                                <option value="100M - 499.9M">100M - 499.9M</option>
                                                <option value="500M - 999.9M">500M - 999.9M</option>
                                                <option value="1B - 4.9B">1B - 4.9B</option>
                                                <option value="5B and Above">5B and Above</option>
                                            </select>
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label>{this.props.fieldValues.type.includes("kyc") ? "Tax Identification No" : "National Identification No"}<span className="text-danger">*</span></label>
                                            <Form.Control required type="text" className="form-control uint" ref="id_no" placeholder={this.props.fieldValues.type.includes("kyc") ? "Tax Identification No" : "National Identification No"} defaultValue={this.props.fieldValues.id_no} />
                                        </Form.Group>
                                        <Form.Group className="col-lg-3 col-md-4 col-sm-6">
                                            <label htmlFor="attachments"><i className="fa fa-paperclip"></i> Passport<span className="text-danger">*</span></label>
                                            <Form.Control onChange={this.onChangePassport} type="file" className="form-control" ref="passport" accept=".jpeg,.jpg,.gif,.png" required />
                                        </Form.Group>
                                    </div>
                                    <button type="submit" className="btn btn-primary mr-2">Save and Continue</button>
                                </form>
                            </div >
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CompanyProfile;